import { render } from "./InspectionPlanProductList.vue?vue&type=template&id=9f983008"
import script from "./InspectionPlanProductList.vue?vue&type=script&lang=js"
export * from "./InspectionPlanProductList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__